module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "pa_main_search_inner"
  }, [_c('el-form', {
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "search_ipt_box con_box p_tb5"
  }, [_c('el-input', {
    staticClass: "no_border",
    attrs: {
      "prefix-icon": "el-icon-search",
      "placeholder": "输入会员手机号或昵称"
    },
    model: {
      value: (_vm.user_search),
      callback: function($$v) {
        _vm.user_search = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "user_search"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "pa_btn",
    attrs: {
      "size": "max",
      "type": "FF7"
    },
    on: {
      "click": _vm.searchUser
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "pa_btn",
    attrs: {
      "size": "max",
      "type": "FF7"
    },
    on: {
      "click": function($event) {
        _vm.newUserDialog = true
      }
    }
  }, [_vm._v("新增会员")])], 1)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true
    }
  }, _vm._l((_vm.userGroupList), function(item, index) {
    return _c('el-form-item', {
      key: index
    }, [_c('el-button', {
      staticClass: "pa_btn",
      class: _vm.user_group_id == item.group_id ? 'on' : '',
      attrs: {
        "size": "small",
        "type": "FFF"
      },
      on: {
        "click": function($event) {
          return _vm.selectGroupItem(item)
        }
      }
    }, [_vm._v(_vm._s(item.group_name))])], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "pa_table_box"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "font-size": "12px"
    },
    attrs: {
      "data": _vm.tableData
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "user",
      "width": "200",
      "label": "会员信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "pa_user_list_info_box"
        }, [_c('img', {
          staticClass: "img",
          class: row.user_avatar ? '' : 'default_img',
          attrs: {
            "src": (row.user_avatar && (row.user_avatar).indexOf('https') == -1) ?
              ("" + (_vm.$config.img_url) + (row.user_avatar)) : row.user_avatar
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "text"
        }, [_c('span', [_vm._v(_vm._s(row.user_nickname))]), _vm._v(" "), _c('span', {
          staticClass: "numbers"
        }, [_vm._v("编号:" + _vm._s(row.card_no ? row.card_no : '--'))])])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "mobile",
      "label": "手机号码"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "integral",
      "sortable": "",
      "label": "会员级别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v(_vm._s(row.group_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "available_balance",
      "sortable": "",
      "label": "会员资产"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v("余额:" + _vm._s(row.available_balance))]), _vm._v(" "), _c('div', [_vm._v("成长值:" + _vm._s(row.integral))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "count_amount",
      "sortable": "",
      "label": "消费情况"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v("累计消费:" + _vm._s(row.count_amount))]), _vm._v(" "), _c('div', [_vm._v("最近消费:" + _vm._s(row.last_order_amount))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "merchant_name",
      "label": "归属门店"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "宠物档案"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "list_button",
          attrs: {
            "size": "text"
          },
          on: {
            "click": function($event) {
              return _vm.petDataList(scope.row.user_id)
            }
          }
        }, [_vm._v("宠物列表")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "prop": "updated_at",
      "sortable": "",
      "label": "最后到店时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "prop": "zip",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          staticClass: "list_button",
          attrs: {
            "size": "text"
          },
          on: {
            "click": function($event) {
              return _vm.userInfo(row.user_id)
            }
          }
        }, [_vm._v("查看详情")]), _vm._v(" "), (_vm.isShowDel(row)) ? _c('el-button', {
          staticClass: "list_button",
          attrs: {
            "size": "text"
          },
          on: {
            "click": function($event) {
              return _vm.userDel(row.user_id)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "total": _vm.tableForm.total,
      "page": _vm.tableForm.page,
      "limit": _vm.tableForm.limit
    },
    on: {
      "update:page": function($event) {
        return _vm.$set(_vm.tableForm, "page", $event)
      },
      "update:limit": function($event) {
        return _vm.$set(_vm.tableForm, "limit", $event)
      },
      "pagination": _vm.initData
    }
  })], 1), _vm._v(" "), _c('alertPop', {
    attrs: {
      "status": _vm.exportDialog,
      "size": "mini",
      "conText": _vm.exportContent,
      "type": "2"
    },
    on: {
      "clock": _vm.popCloseTap
    }
  }), _vm._v(" "), _c('addUser', {
    attrs: {
      "status": _vm.newUserDialog,
      "size": "small"
    },
    on: {
      "add": _vm.addUserTap
    }
  }), _vm._v(" "), _c('petList', {
    attrs: {
      "status": _vm.petListDialog,
      "size": "max",
      "uid": _vm.current_uid
    },
    on: {
      "add": _vm.petListTap
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20a4a360"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/member/list/user.vue
// module id = 3495
// module chunks = 103